// Copied from Ascend
import { Box, TabPanelProps } from "@chakra-ui/react";
import React from "react";

import { RouteTabsContext } from "./RouteTabs";

export interface RouteTabPanelProps extends TabPanelProps {
  routeName: string;
}

/**
 * The TabPanel component that is controlled by the router.
 *
 * @param props `RouteTabProps`
 * @param props.routeName The name of the route that will enable the panel.
 * @example <RouteTabPanel routeName="summary">Content</RouteTabPanel>
 */
export const RouteTabPanel = ({
  children,
  routeName,
  ...restProps
}: RouteTabPanelProps) => {
  const { routeParam } = React.useContext(RouteTabsContext);
  if (routeName === routeParam) {
    return <Box {...restProps}>{children}</Box>;
  }
  return null;
};
